import {useEffect, useState} from "react";
import {closePopup2, openPopup2, selectEvent} from "utils/CommonUtils";
import {dongLabelActiveEvent} from "utils/shopUtils";
import {getAdminAddrMgtApi, setOrderShopApi} from "api/shopApi";
import cross from "assets/icon/cross.svg";
import {areaCodeList} from "data/areaData";

const ShopInfo5Popup = ({shopId, shopDongList, setErrorMessage}) => {
  const [resetCount, setResetCount] = useState(1);
  const [sidoValue, setSidoValue] = useState(0);
  const [sigunguValue, setSigunguValue] = useState(0);
  const [dongList, setDongList] = useState([]);

  // 팝업창 닫기 이벤트
  const closeEvent = () => {
    closePopup2("shopInfo5Popup");
    // 리셋 카운터 값을 변경해 데이터 초기화
    setResetCount(resetCount + 1);
  }

  // 초기화 이벤트
  useEffect(() => {
    setSidoValue(0);
    setSigunguValue(0)
    setDongList([]);

    if (shopDongList.length !== 0) {
      selectEvent("sigunguSelect", "미선택", 0);
    }
  }, [resetCount]);

  // 시도 선택 이벤트
  const areaSelectEvent = async (id, name, code) => {
    selectEvent(id, name, code);
    if (id === "sidoSelect") {
      setSidoValue(code);
      setSigunguValue(0);
      setDongList([]);
      selectEvent("sigunguSelect", "미선택", 0);
    }

    if (id === "sigunguSelect") {
      setSigunguValue(code);

      const searchData = {
        sido: areaCodeList.find((value) => value.code === sidoValue).name,
        sigungu: name
      }

      let getDongList = [];

      try {
        getDongList = await getAdminAddrMgtApi(searchData);
      } catch (e) {

      }

      setDongList(getDongList);
    }
  }

  // 시군구 셀렉트 생성
  const sigunguSelect = () => {
    const sigunguList = areaCodeList.find((value) => value.code === sidoValue)?.sub || [];
    const sigunguName = sigunguList.find((value) => value.code === sigunguList)?.name || "미선택";

    return (
      <>
        <div className="selectText2 ellipsis-1" data-href="sigunguSelect" data-id={sigunguValue}>
          {sigunguName}
        </div>
        <div id="sigunguSelectUl" className="selectOptionListBox2 scrollbar d-none bc-FF br-6">
          {sigunguList.map((value, index) => {
            return (
              <div
                key={index}
                className="ellipsis-1"
                onClick={() => areaSelectEvent("sigunguSelect", value.name, value.code)}
              >
                {value.name}
              </div>
            )
          })}
        </div>
      </>
    )
  }

  // 수정 이벤트
  const setEvent = async () => {
    openPopup2("loadingPopup");
    
    let addDeliverableAreaList = [];
    let removeDeliverableAreaList = [];

    const subDongLabel = document.querySelectorAll(".subDongLabel");
    subDongLabel.forEach(element => {
      const sido = element.getAttribute("data-sido");
      const sigungu = element.getAttribute("data-sigungu");
      let sigunguName = sigungu;
      if (sigungu === "창원시마산합포구") {
        sigunguName = "창원시 마산합포구"
      }

      const dongName = element.innerText;
      const isActive = element.classList.contains("active");
      const getDongData = shopDongList.find((value) => value === `${sido} ${sigungu} ${dongName}`);

      if (getDongData && !isActive) {
        removeDeliverableAreaList.push(`${sido} ${sigunguName} ${dongName}`)
      } else if (!getDongData && isActive) {
        addDeliverableAreaList.push(`${sido} ${sigunguName} ${dongName}`);
      }
    });

    const data = {}

    if (addDeliverableAreaList.length === 0 && removeDeliverableAreaList.length === 0) {
      setErrorMessage("변경된 내용이 없습니다.");
      closePopup2("loadingPopup");
      openPopup2("messagePopup");
      return false;
    }

    if (addDeliverableAreaList.length > 0) data.addDeliverableAreaList = addDeliverableAreaList;
    if (removeDeliverableAreaList.length > 0) data.removeDeliverableAreaList = removeDeliverableAreaList;

    try {
      await setOrderShopApi(shopId, data);
      window.location.reload();
    } catch (e) {
      setErrorMessage("오류가 발생했습니다.");
      closePopup2("loadingPopup");
      openPopup2("messagePopup");
    }
  }

  return (
    <div className="newStyle">
      <div id="shopInfo5Popup" className="shopInfo5Popup popupContainer d-flex a-center j-center d-none">
        <div className="popupBody bc-FF">
          <div className="titleBox d-flex a-center j-between">
            <p className="fs-24 fw-7">배달 권역 설정</p>
            <button onClick={closeEvent}>
              <img src={cross} alt="닫기" />
            </button>
          </div>
          <div className="bodyBox scrollbar">
            <div className="popupInputBox d-flex a-center j-left mb-15">
              <div className="inputLabel fw-7">시/도 선택</div>
              <div className="inputBox d-flex a-center j-left">
                <div id="sidoSelect" className="select2 bc-FF br-6 mr-10">
                  <div className="selectText2 ellipsis-1" data-href="sidoSelect" data-id={sidoValue}>
                    {areaCodeList.find((value) => value.code === sidoValue).name}
                  </div>
                  <div id="sidoSelectUl" className="selectOptionListBox2 scrollbar d-none bc-FF br-6">
                    {areaCodeList.map((value, index) => {
                      return (
                        <div
                          key={index}
                          className="ellipsis-1"
                          onClick={() => areaSelectEvent("sidoSelect", value.name, value.code)}
                        >
                          {value.name}
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="popupInputBox d-flex a-center j-left mb-15">
              <div className="inputLabel fw-7">시/군/구 선택</div>
              <div id="sigunguSelect" className="select2 bc-FF br-6 mr-10">
                {sigunguSelect()}
              </div>
            </div>
            <div className="popupInputBox">
              <div className="fw-7 mb-5">읍면동 선택</div>
              <div className="dongListBox">
                {dongList.length === 0 ?
                  <p className="mb-15">선택할 수 있는 지역이 없습니다.</p> :
                  <>
                    {(() => {
                      const allActive = dongList.every((value) =>
                        shopDongList.some((item) => item === `${value.sido} ${value.sigungu} ${value.admstrDong}`)
                      );
                      return (
                        <label
                          id="allDongLabel"
                          className={`dongLabel fs-15 fw-7 br-6 mr-5 mb-5 d-inline ta-center ${
                            allActive ? "active" : ""
                          }`}
                          onClick={(e) => dongLabelActiveEvent(e)}
                        >
                          전체
                        </label>
                      );
                    })()}
                    {dongList.map((value, index) => {
                      if (value.admstrDong) {
                        const active = shopDongList.some((item) => item === `${value.sido} ${value.sigungu} ${value.admstrDong}`);

                        return (
                          <label
                            className={`subDongLabel dongLabel fs-15 fw-7 br-6 mr-5 mb-5 d-inline ta-center ${active ? "active" : ""}`}
                            key={index}
                            data-sido={value.sido}
                            data-sigungu={value.sigungu}
                            onClick={(e) => dongLabelActiveEvent(e)}
                          >
                            {value.admstrDong}
                          </label>
                        )
                      } else {
                        return false;
                      }
                    })}
                  </>
                }
              </div>
            </div>
          </div>
          <div className="btnBox">
            <button
              className="fs-20 fw-7 bc bc-ACB2B8 fc-FF"
              onClick={closeEvent}
            >
              취소
            </button>
            <button className="fs-20 fw-7 bc-0764A9 fc-FF" onClick={setEvent}>수정</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopInfo5Popup;